export const EKOWITRYNA_SUBSCRIPTION_URL = 'https://ekowitryna.pl/subskrypcja/';
